import { useState, useCallback } from 'react';
import { EventsController } from '../core';

const useEvents = () => {
  const [events, setEvents] = useState([]);
  const [userEvents, setUserEvents] = useState([]);
  const [eventAttendees, setEventAttendees] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState('');
  const [attendeeEmail, setAttendeeEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingEvents, setLoadingEvents] = useState(false);
  const [error, setError] = useState(null);

  const loadTodayEvents = useCallback(async (email) => {
    setLoading(true);
    setError(null);
    
    const result = await EventsController.getTodayEvents(email);
    
    if (result.success) {
      setEvents(result.data);
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  }, []);

  const loadUserEvents = useCallback(async (email) => {
    setLoadingEvents(true);
    setError(null);
    
    const result = await EventsController.getUserEvents(email);
    
    if (result.success) {
      setUserEvents(result.data);
    } else {
      setError(result.error);
    }
    
    setLoadingEvents(false);
  }, []);

  const loadEventAttendees = useCallback(async (eventId, email) => {
    setLoading(true);
    setError(null);
    
    const result = await EventsController.getEventAttendees(eventId, email);
    
    if (result.success) {
      setEventAttendees(result.data);
    } else {
      setError(result.error);
    }
    
    setLoading(false);
  }, []);

  const selectEvent = useCallback((event) => {
    setSelectedEvent(event);
    setError(null);
  }, []);

  const selectEventId = useCallback((eventId) => {
    setSelectedEventId(eventId);
    setError(null);
  }, []);

  const setAttendeeEmailValue = useCallback((email) => {
    setAttendeeEmail(email);
  }, []);

  const clearEvents = useCallback(() => {
    setEvents([]);
    setEventAttendees([]);
    setSelectedEventId('');
    setError(null);
  }, []);
  
  const clearEventAttendees = useCallback(() => {
    setEventAttendees([]);
    setError(null);
  }, []);

  const getEventDbId = useCallback(async (googleEventId, eventDetails) => {
    const result = await EventsController.getOrCreateEvent(googleEventId, eventDetails);
    return result.success ? result.data : null;
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    // State
    events,
    userEvents,
    eventAttendees,
    selectedEvent,
    selectedEventId,
    attendeeEmail,
    loading,
    loadingEvents,
    error,
    
    // Actions
    loadTodayEvents,
    loadUserEvents,
    loadEventAttendees,
    selectEvent,
    selectEventId,
    setAttendeeEmailValue,
    clearEvents,
    clearEventAttendees,
    getEventDbId,
    clearError
  };
};

export default useEvents;